import { TabContext, TabList, TabPanel } from '@material-ui/lab'
import { Tab,  } from '@mui/material'
import { Box } from '@mui/system'
import React, { useContext,  } from 'react'
import { Pagination, Navigation } from "swiper";
import { SwiperSlide,Swiper } from 'swiper/react'
import { ProductContext } from '../Context/ProductProvider';
import TScard from '../SmallComponents/TScard';


const TrendingEarpone = () => {

    const [value, setValue] = React.useState('1');
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const {state:{product}} = useContext(ProductContext);
    const earbuds = product.filter((e)=>{
        return e.category === 'earbuds'
    })
    const wireless = product.filter((e)=>{
    
        return e.category === 'wireless'
    })
    const wired = product.filter((e)=>{
        return e.category === 'wired'
    })
    const stylePrimary = {
      color: 'red',
      fontWeight: 'bolder'
    }
    const styleSecondary = {
      color: 'gray',
      fontWeight: 'bold'
    }

  return (
        <Box bgcolor='black' pt={10} pb={5} >
            <Box sx={{ maxWidth: '75vw', typography: 'body1', margin: 'auto', position: 'relative', left: '-1rem'}}>
              <h1 style={{color: 'white'}}> Trending Earpones</h1>
              <TabContext value={value}>
                <Box sx={{  width:'fit-content' }}>
                  <TabList onChange={handleChange} aria-label="lab API tabs example">
                    <Tab label="Earbuds" value="1" style={value === '1'? stylePrimary: styleSecondary} />
                    <Tab label="Wired" value="2" style={value === '2'? stylePrimary: styleSecondary} />
                    <Tab label="Wireless" value="3"style={value === '3'? stylePrimary: styleSecondary} />
                  </TabList>
                </Box>


                
                {/* ====================TAB 1 ============== */}
                <TabPanel value="1">
                    <Box style={{width: '75vw', display:'flex',  }}>
                        <Swiper
                          slidesPerView={4}
                          spaceBetween={30}
                          loop={false}
                          loopFillGroupWithBlank={true}
                          pagination={{
                            clickable: true,
                          }}
                          navigation={true}
                          modules={[Pagination, Navigation]}
                          breakpoints={
                            {
                                320: {
                                  slidesPerView: 1,
                                  slidesPerGroup: 1,
                                  spaceBetween: 100
                                },
                                500: {
                                  slidesPerView: 2,
                                  slidesPerGroup: 2,
                                  spaceBetween: 20
                                },
                                900: {
                                  slidesPerView: 3,
                                  slidesPerGroup: 3,
                                  spaceBetween: 20
                                },
                                1100:{
                                  slidesPerView: 4,
                                slidesPerGroup: 4,
                                spaceBetween: 20
                              }
                            }
                          }
                        >{earbuds.map((elm, i)=>{
                                return(
                                    <SwiperSlide key={elm.id}>
                                        <TScard name={elm.name} price={elm.price} image={elm.img}  id={elm} />
                                    </SwiperSlide>
                                )
                            })}
                        </Swiper>
                    </Box>
                </TabPanel>



                {/* ====================TAB 2 ============== */}
                <TabPanel value="2">
                <Box style={{width: '75vw', display:'flex',  }}>
                        <Swiper
                          // sx={{slidesPerView:{sm: 1, md:3}, slidesPerGroup:{sm:1, md:2}}}
                          slidesPerView={4}
                          spaceBetween={30}
                          // slidesPerGroup={3}
                          loop={false}
                          loopFillGroupWithBlank={true}
                          pagination={{
                            clickable: true,
                          }}
                          navigation={true}
                          modules={[Pagination, Navigation]}
                          breakpoints={
                            {
                                320: {
                                  slidesPerView: 1,
                                  slidesPerGroup: 1,
                                  spaceBetween: 100
                                },
                                500: {
                                  slidesPerView: 2,
                                  slidesPerGroup: 2,
                                  spaceBetween: 20
                                },
                                900: {
                                  slidesPerView: 3,
                                  slidesPerGroup: 3,
                                  spaceBetween: 20
                                },
                                1100:{
                                  slidesPerView: 4,
                                slidesPerGroup: 4,
                                spaceBetween: 20
                              }
                            }
                          }
                        >{wired.map((elm, i)=>{
                                return(
                                    <SwiperSlide key={elm.id}>
                                        <TScard name={elm.name} price={elm.price} image={elm.img}  id={elm.id} />
                                    </SwiperSlide>
                                )
                            })}
                        </Swiper>
                    </Box>
                </TabPanel>


                {/* ====================TAB 3 ============== */}
                <TabPanel value="3">
                <Box style={{width: '75vw', display:'flex',  }}>
                        <Swiper
                          slidesPerView={4}
                          spaceBetween={30}
                          slidesPerGroup={3}
                          loop={false}
                          loopFillGroupWithBlank={true}
                          pagination={{
                            clickable: true,
                          }}
                          navigation={true}
                          modules={[Pagination, Navigation]}
                          breakpoints={
                            {
                                320: {
                                  slidesPerView: 1,
                                  slidesPerGroup: 1,
                                  spaceBetween: 100
                                },
                                500: {
                                  slidesPerView: 2,
                                  slidesPerGroup: 2,
                                  spaceBetween: 20
                                },
                                900: {
                                  slidesPerView: 3,
                                  slidesPerGroup: 3,
                                  spaceBetween: 20
                                },
                                1100:{
                                  slidesPerView: 4,
                                slidesPerGroup: 4,
                                spaceBetween: 20
                              }
                            }
                          }
                        >{wireless.map((elm, i)=>{
                                return(
                                    <SwiperSlide key={elm.id}>
                                        <TScard name={elm.name} price={elm.price} image={elm.img} key={i} />
                                    </SwiperSlide>
                                )
                            })}
                        </Swiper>
                    </Box>
                </TabPanel>
              </TabContext>
            </Box>
        </Box>
  )
}

export default TrendingEarpone
